import { FC } from 'react';

interface AssistantVoiceBubbleProps {
  audio: { url: string; durationMs: number };
  // What was recognised. It is not written into the chat: it is only the bubble's hover text.
  transcript: string;
}

/** The user's own voice message, with a player so it can be heard again while this page is open. */
const AssistantVoiceBubble: FC<AssistantVoiceBubbleProps> = ({ audio, transcript }) => (
  <div
    className="assistant-chat-bubble assistant-chat-bubble--user assistant-chat-bubble--voice"
    title={transcript || undefined}
  >
    <audio controls preload="metadata" src={audio.url} />
  </div>
);

export default AssistantVoiceBubble;
